import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { createApiForOrg } from '../api/axios';
import { useOrg, getApiBase } from '../org/OrgContext';
import axios from 'axios';

const AuthContext = createContext();


export function AuthProvider({ children }){
const { org } = useOrg();
const [user, setUser] = useState(() => {
try{ return JSON.parse(localStorage.getItem('user')) || null }catch{ return null }
});
const [accessToken, setAccessToken] = useState(() => localStorage.getItem('accessToken') || '');
const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem('refreshToken') || '');
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4321';

const api = useMemo(() => createApiForOrg(
  org,                         // ignored by the axios factory now
  () => accessToken,
  async () => {
    if(!refreshToken) return '';
    try{
      const { data } = await axios.post(`${API_BASE}/auth/refresh`, { refreshToken });
      if (data?.accessToken) {
        setAccessToken(data.accessToken);
        localStorage.setItem('accessToken', data.accessToken);
        return data.accessToken;
      }
    }catch{}
    logout();
    return '';
  }
), [org, accessToken, refreshToken]);

useEffect(()=>{ // clear auth when org changes
if(!org){ logout(true); return; }
},[org]);


function login(payload){
setUser(payload.user); setAccessToken(payload.accessToken); setRefreshToken(payload.refreshToken);
localStorage.setItem('user', JSON.stringify(payload.user));
localStorage.setItem('accessToken', payload.accessToken);
localStorage.setItem('refreshToken', payload.refreshToken);
}
function logout(keepOrg=false){
setUser(null); setAccessToken(''); setRefreshToken('');
localStorage.removeItem('user'); localStorage.removeItem('accessToken'); localStorage.removeItem('refreshToken');
if(!keepOrg){ localStorage.removeItem('org'); }
}


const value = useMemo(()=>({ user, login, logout, api }), [user, api]);
return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}


export function useAuth(){
const ctx = useContext(AuthContext);
if(!ctx) throw new Error('useAuth must be used within AuthProvider');
return ctx;
}